export default {
    VIEWPORT_DEFAULT_VALUE: '-1'
};



// WEBPACK FOOTER //
// ./core/constants.js